import { TherapeuticArea } from '~/Api/Analytics/Autocomplete/TherapeuticArea';

import ActionTypes from './ActionTypes';

export interface TherapeuticAreasState {
	request: Promise<any>;
	isFetching: boolean;
	items: TherapeuticArea[] | null;
}

export interface State {
	byFilter: { [key: string]: TherapeuticAreasState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			filter: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			filter: string;
			items: TherapeuticArea[] | null;
	  };

function createState(): State {
	return { byFilter: {} };
}

export default function reducer(state: State = createState(), action: Action) {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						request: action.request,
						isFetching: true,
						items: [],
					},
				},
			};

		case ActionTypes.receive: {
			const therapeuticAreasState = state.byFilter[action.filter];
			if (therapeuticAreasState?.request !== action.request) {
				return state;
			}
			if (!action.items) {
				const byFilter = { ...state.byFilter };
				delete byFilter[action.filter];
				return { ...state, byFilter };
			}

			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						...therapeuticAreasState,
						isFetching: false,
						items: action.items,
					},
				},
			};
		}

		default:
			return state;
	}
}

export function selectTherapeuticAreas(state: State, filter: string): TherapeuticAreasState | null {
	return state.byFilter[filter.slice(0, 1)] || null;
}
